"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCorrection = exports.validateCorrection = exports.stampFromTransaction = exports.extractTransaction = exports.fixCorrection = exports.correctionToDynamoDBDocClientObject = exports.dynamodbRecordToCorrection = void 0;
const correction_1 = require("./correction");
const string_utils_1 = require("./string-utils");
function dynamodbRecordToCorrection(record) {
    const correction = new correction_1.Correction();
    if (record.dynamodb) {
        const dynamodb = record.dynamodb;
        const newImage = dynamodb.NewImage;
        if (newImage) {
            correction.correctionKey = (newImage.CorrectionKey) ? newImage.CorrectionKey.S || '' : correction.correctionKey;
            correction.eventDatetime = (newImage.EventDatetime) ? newImage.EventDatetime.S || '' : correction.eventDatetime;
            correction.type = (newImage.Type) ? newImage.Type.S || '' : correction.type;
            correction.settleDate = (newImage.SettleDate) ? newImage.SettleDate.S || '' : correction.settleDate;
            correction.direction = (newImage.Direction) ? newImage.Direction.S || '' : correction.direction;
            correction.currency = (newImage.Currency) ? newImage.Currency.S || '' : correction.currency;
            correction.amount = (newImage.Amount) ? parseFloat(newImage.Amount.N || '0') : correction.amount;
            correction.desk = (newImage.Desk) ? newImage.Desk.S || '' : correction.desk;
            correction.changeReason = (newImage.ChangeReason) ? newImage.ChangeReason.S || '' : correction.changeReason;
            correction.username = (newImage.Username) ? newImage.Username.S || '' : correction.username;
            correction.account = (newImage.Account) ? newImage.Account.S || '' : correction.account;
            correction.balanceCorrectionCalculatedAmount = (newImage.BalanceCorrectionCalculatedAmount) ? parseFloat(newImage.BalanceCorrectionCalculatedAmount.N || '0') : correction.balanceCorrectionCalculatedAmount;
            correction.balanceCorrectionOfficialAmount = (newImage.BalanceCorrectionOfficialAmount) ? parseFloat(newImage.BalanceCorrectionOfficialAmount.N || '0') : correction.balanceCorrectionOfficialAmount;
            correction.projectionUpdateClientGroup = (newImage.ProjectionUpdateClientGroup) ? newImage.ProjectionUpdateClientGroup.S || '' : correction.projectionUpdateClientGroup;
            correction.projectionUpdateProductType = (newImage.ProjectionUpdateProductType) ? newImage.ProjectionUpdateProductType.S || '' : correction.projectionUpdateProductType;
            correction.projectionUpdateOriginalAmount = (newImage.ProjectionUpdateOriginalAmount) ? parseFloat(newImage.ProjectionUpdateOriginalAmount.N || '0') : correction.projectionUpdateOriginalAmount;
            correction.projectionUpdateNewAmount = (newImage.ProjectionUpdateNewAmount) ? parseFloat(newImage.ProjectionUpdateNewAmount.N || '0') : correction.projectionUpdateNewAmount;
            correction.txnFlowKey = (newImage.TxnFlowKey) ? newImage.TxnFlowKey.S || '' : correction.txnFlowKey;
            correction.txnEventDatetime = (newImage.TxnEventDatetime) ? newImage.TxnEventDatetime.S || '' : correction.txnEventDatetime;
            correction.txnSettleDate = (newImage.TxnSettleDate) ? newImage.TxnSettleDate.S || '' : correction.txnSettleDate;
            correction.txnDirection = (newImage.TxnDirection) ? newImage.TxnDirection.S || '' : correction.txnDirection;
            correction.txnCurrency = (newImage.TxnCurrency) ? newImage.TxnCurrency.S || '' : correction.txnCurrency;
            correction.txnAmount = (newImage.TxnAmount) ? parseFloat(newImage.TxnAmount.N || '0') : correction.txnAmount;
            correction.txnOrganization = (newImage.TxnOrganization) ? newImage.TxnOrganization.S || '' : correction.txnOrganization;
            correction.txnOrganizationLevel = (newImage.TxnOrganizationLevel) ? newImage.TxnOrganizationLevel.S || '' : correction.txnOrganizationLevel;
            correction.txnDesk = (newImage.TxnDesk) ? newImage.TxnDesk.S || '' : correction.txnDesk;
            correction.txnTradeDatetime = (newImage.TxnTradeDatetime) ? newImage.TxnTradeDatetime.S || '' : correction.txnTradeDatetime;
            correction.txnAccount = (newImage.TxnAccount) ? newImage.TxnAccount.S || '' : correction.txnAccount;
            correction.txnPredictionEligible = (newImage.TxnPredictionEligible) ? string_utils_1.isTrueString(newImage.TxnPredictionEligible.S) || false : correction.txnPredictionEligible;
            correction.txnTimeSpecific = (newImage.TxnTimeSpecific) ? string_utils_1.isTrueString(newImage.TxnTimeSpecific.S) || false : correction.txnTimeSpecific;
            correction.txnSettleTime = (newImage.TxnSettleTime) ? newImage.TxnSettleTime.S || '' : correction.txnSettleTime;
            correction.txnTimeZone = (newImage.TxnTimeZone) ? newImage.TxnTimeZone.S || '' : correction.txnTimeZone;
            correction.txnClient = (newImage.TxnClient) ? newImage.TxnClient.S || '' : correction.txnClient;
            correction.txnClientGroup = (newImage.TxnClientGroup) ? newImage.TxnClientGroup.S || '' : correction.txnClientGroup;
            correction.txnSupplementaryRef = (newImage.TxnSupplementaryRef) ? newImage.TxnSupplementaryRef.S || '' : correction.txnSupplementaryRef;
            correction.txnProduct = (newImage.TxnProduct) ? newImage.TxnProduct.S || '' : correction.txnProduct;
            correction.txnProductType = (newImage.TxnProductType) ? newImage.TxnProductType.S || '' : correction.txnProductType;
            correction.txnTrader = (newImage.TxnTrader) ? newImage.TxnTrader.S || '' : correction.txnTrader;
            correction.txnClearing = (newImage.TxnClearing) ? string_utils_1.isTrueString(newImage.TxnClearing.S) || false : correction.txnClearing;
            correction.txnSource = (newImage.TxnSource) ? newImage.TxnSource.S || '' : correction.txnSource;
            correction.txnExternalId = (newImage.TxnExternalId) ? newImage.TxnExternalId.S || '' : correction.txnExternalId;
            correction.txnSecondaryId = (newImage.TxnSecondaryId) ? newImage.TxnSecondaryId.S || '' : correction.txnSecondaryId;
            correction.txnFlowScope = (newImage.TxnFlowScope) ? parseFloat(newImage.TxnFlowScope.N || '0') : correction.txnFlowScope;
            correction.txnFlowType = (newImage.TxnFlowType) ? newImage.TxnFlowType.S || '' : correction.txnFlowType;
            correction.txnTimeStamp = (newImage.TxnTimeStamp) ? newImage.TxnTimeStamp.S || '' : correction.txnTimeStamp;
            correction.txnClientSpecificInfo = (newImage.TxnClientSpecificInfo) ? newImage.TxnClientSpecificInfo.S || '' : correction.txnClientSpecificInfo;
            correction.txnOrderingCustomer = (newImage.TxnOrderingCustomer) ? newImage.TxnOrderingCustomer.S || '' : correction.txnOrderingCustomer;
            correction.txnOrderingInstitution = (newImage.TxnOrderingInstitution) ? newImage.TxnOrderingInstitution.S || '' : correction.txnOrderingInstitution;
            correction.txnSendersCorrespondent = (newImage.TxnSendersCorrespondent) ? newImage.TxnSendersCorrespondent.S || '' : correction.txnSendersCorrespondent;
            correction.txnReceiversCorrespondent = (newImage.TxnReceiversCorrespondent) ? newImage.TxnReceiversCorrespondent.S || '' : correction.txnReceiversCorrespondent;
            correction.txnThirdReimbursementInstitution = (newImage.TxnThirdReimbursementInstitution) ? newImage.TxnThirdReimbursementInstitution.S || '' : correction.txnThirdReimbursementInstitution;
            correction.txnIntermediaryInstitution = (newImage.TxnIntermediaryInstitution) ? newImage.TxnIntermediaryInstitution.S || '' : correction.txnIntermediaryInstitution;
            correction.txnAccountWithInstitution = (newImage.TxnAccountWithInstitution) ? newImage.TxnAccountWithInstitution.S || '' : correction.txnAccountWithInstitution;
            correction.txnBeneficiaryCustomer = (newImage.TxnBeneficiaryCustomer) ? newImage.TxnBeneficiaryCustomer.S || '' : correction.txnBeneficiaryCustomer;
            correction.txnBeneficiaryInstitution = (newImage.TxnBeneficiaryInstitution) ? newImage.TxnBeneficiaryInstitution.S || '' : correction.txnBeneficiaryInstitution;
            correction.txnCreditLine = (newImage.TxnCreditLine) ? newImage.TxnCreditLine.S || '' : correction.txnCreditLine;
            correction.txnPayClientAccount = (newImage.TxnPayClientAccount) ? newImage.TxnPayClientAccount.S || '' : correction.txnPayClientAccount;
            correction.txnRecClientAccount = (newImage.TxnRecClientAccount) ? newImage.TxnRecClientAccount.S || '' : correction.txnRecClientAccount;
            correction.txnFxCcyPair = (newImage.TxnFxCcyPair) ? newImage.TxnFxCcyPair.S || '' : correction.txnFxCcyPair;
            correction.txnFxFxRate = (newImage.TxnFxFxRate) ? parseFloat(newImage.TxnFxFxRate.N || '0') : correction.txnFxFxRate;
            correction.txnFxExecutionSystem = (newImage.TxnFxExecutionSystem) ? newImage.TxnFxExecutionSystem.S || '' : correction.txnFxExecutionSystem;
            correction.txnFxBuySell = (newImage.TxnFxBuySell) ? newImage.TxnFxBuySell.S || '' : correction.txnFxBuySell;
            correction.txnFxTenor = (newImage.TxnFxTenor) ? newImage.TxnFxTenor.S || '' : correction.txnFxTenor;
            correction.txnMmRate = (newImage.TxnMmRate) ? parseFloat(newImage.TxnMmRate.N || '0') : correction.txnMmRate;
            correction.txnMmRateIndex = (newImage.TxnMmRateIndex) ? newImage.TxnMmRateIndex.S || '' : correction.txnMmRateIndex;
            correction.txnMmSpread = (newImage.TxnMmSpread) ? parseFloat(newImage.TxnMmSpread.N || '0') : correction.txnMmSpread;
            correction.txnMmMaturityDate = (newImage.TxnMmMaturityDate) ? newImage.TxnMmMaturityDate.S || '' : correction.txnMmMaturityDate;
            correction.txnMmSettleDate = (newImage.TxnMmSettleDate) ? newImage.TxnMmSettleDate.S || '' : correction.txnMmSettleDate;
            correction.txnMmLoanDepo = (newImage.TxnMmLoanDepo) ? newImage.TxnMmLoanDepo.S || '' : correction.txnMmLoanDepo;
            correction.txnBondIsin = (newImage.TxnBondIsin) ? newImage.TxnBondIsin.S || '' : correction.txnBondIsin;
            correction.txnBondPrice = (newImage.TxnBondPrice) ? parseFloat(newImage.TxnBondPrice.N || '0') : correction.txnBondPrice;
            correction.txnBondBuySell = (newImage.TxnBondBuySell) ? newImage.TxnBondBuySell.S || '' : correction.txnBondBuySell;
            correction.txnBondOutstandingPrincipal = (newImage.TxnBondOutstandingPrincipal) ? parseFloat(newImage.TxnBondOutstandingPrincipal.N || '0') : correction.txnBondOutstandingPrincipal;
            correction.txnRepoRate = (newImage.TxnRepoRate) ? parseFloat(newImage.TxnRepoRate.N || '0') : correction.txnRepoRate;
            correction.txnRepoMaturityDate = (newImage.TxnRepoMaturityDate) ? newImage.TxnRepoMaturityDate.S || '' : correction.txnRepoMaturityDate;
            correction.txnRepoSettleDate = (newImage.TxnRepoSettleDate) ? newImage.TxnRepoSettleDate.S || '' : correction.txnRepoSettleDate;
            correction.txnRepoSecurity = (newImage.TxnRepoSecurity) ? newImage.TxnRepoSecurity.S || '' : correction.txnRepoSecurity;
            correction.txnRepoRepoReverse = (newImage.TxnRepoRepoReverse) ? newImage.TxnRepoRepoReverse.S || '' : correction.txnRepoRepoReverse;
            correction.txnPaymentPurpose = (newImage.TxnPaymentPurpose) ? newImage.TxnPaymentPurpose.S || '' : correction.txnPaymentPurpose;
            correction.txnExportBillCommodity = (newImage.TxnExportBillCommodity) ? newImage.TxnExportBillCommodity.S || '' : correction.txnExportBillCommodity;
            correction.txnExportBillBillDate = (newImage.TxnExportBillBillDate) ? newImage.TxnExportBillBillDate.S || '' : correction.txnExportBillBillDate;
            correction.txnExportBillImporter = (newImage.TxnExportBillImporter) ? newImage.TxnExportBillImporter.S || '' : correction.txnExportBillImporter;
            correction.txnExportBillImporterBank = (newImage.TxnExportBillImporterBank) ? newImage.TxnExportBillImporterBank.S || '' : correction.txnExportBillImporterBank;
            correction.txnExportBillSettleDate = (newImage.TxnExportBillSettleDate) ? newImage.TxnExportBillSettleDate.S || '' : correction.txnExportBillSettleDate;
            correction.txnImportBillCommodity = (newImage.TxnImportBillCommodity) ? newImage.TxnImportBillCommodity.S || '' : correction.txnImportBillCommodity;
            correction.txnImportBillBillDate = (newImage.TxnImportBillBillDate) ? newImage.TxnImportBillBillDate.S || '' : correction.txnImportBillBillDate;
            correction.txnImportBillExporter = (newImage.TxnImportBillExporter) ? newImage.TxnImportBillExporter.S || '' : correction.txnImportBillExporter;
            correction.txnImportBillExporterBank = (newImage.TxnImportBillExporterBank) ? newImage.TxnImportBillExporterBank.S || '' : correction.txnImportBillExporterBank;
            correction.txnImportBillSettleDate = (newImage.TxnImportBillSettleDate) ? newImage.TxnImportBillSettleDate.S || '' : correction.txnImportBillSettleDate;
            correction.txnExportLcImporter = (newImage.TxnExportLcImporter) ? newImage.TxnExportLcImporter.S || '' : correction.txnExportLcImporter;
            correction.txnExportLcImporterBank = (newImage.TxnExportLcImporterBank) ? newImage.TxnExportLcImporterBank.S || '' : correction.txnExportLcImporterBank;
            correction.txnExportLcLcConditions = (newImage.TxnExportLcLcConditions) ? newImage.TxnExportLcLcConditions.S || '' : correction.txnExportLcLcConditions;
            correction.txnExportLcTenor = (newImage.TxnExportLcTenor) ? newImage.TxnExportLcTenor.S || '' : correction.txnExportLcTenor;
            correction.txnImportLcExporter = (newImage.TxnImportLcExporter) ? newImage.TxnImportLcExporter.S || '' : correction.txnImportLcExporter;
            correction.txnImportLcExporterBank = (newImage.TxnImportLcExporterBank) ? newImage.TxnImportLcExporterBank.S || '' : correction.txnImportLcExporterBank;
            correction.txnImportLcLcConditions = (newImage.TxnImportLcLcConditions) ? newImage.TxnImportLcLcConditions.S || '' : correction.txnImportLcLcConditions;
            correction.txnImportLcTenor = (newImage.TxnImportLcTenor) ? newImage.TxnImportLcTenor.S || '' : correction.txnImportLcTenor;
            correction.txnLoanProduct = (newImage.TxnLoanProduct) ? newImage.TxnLoanProduct.S || '' : correction.txnLoanProduct;
            correction.txnLoanRate = (newImage.TxnLoanRate) ? parseFloat(newImage.TxnLoanRate.N || '0') : correction.txnLoanRate;
            correction.txnLoanRateIndex = (newImage.TxnLoanRateIndex) ? newImage.TxnLoanRateIndex.S || '' : correction.txnLoanRateIndex;
            correction.txnLoanSpread = (newImage.TxnLoanSpread) ? parseFloat(newImage.TxnLoanSpread.N || '0') : correction.txnLoanSpread;
            correction.txnLoanMaturityDate = (newImage.TxnLoanMaturityDate) ? newImage.TxnLoanMaturityDate.S || '' : correction.txnLoanMaturityDate;
            correction.txnLoanSettleDate = (newImage.TxnLoanSettleDate) ? newImage.TxnLoanSettleDate.S || '' : correction.txnLoanSettleDate;
            correction.txnLoanOutstandingPrincipal = (newImage.TxnLoanOutstandingPrincipal) ? parseFloat(newImage.TxnLoanOutstandingPrincipal.N || '0') : correction.txnLoanOutstandingPrincipal;
            correction.txnDepositProduct = (newImage.TxnDepositProduct) ? newImage.TxnDepositProduct.S || '' : correction.txnDepositProduct;
            correction.txnDepositRate = (newImage.TxnDepositRate) ? parseFloat(newImage.TxnDepositRate.N || '0') : correction.txnDepositRate;
            correction.txnDepositMaturityDate = (newImage.TxnDepositMaturityDate) ? newImage.TxnDepositMaturityDate.S || '' : correction.txnDepositMaturityDate;
            correction.txnDepositSettleDate = (newImage.TxnDepositSettleDate) ? newImage.TxnDepositSettleDate.S || '' : correction.txnDepositSettleDate;
        }
    }
    return correction;
}
exports.dynamodbRecordToCorrection = dynamodbRecordToCorrection;
// ------ End   of Schemer Auto Generated Code Block (Correction DynamoDB to TS Converter) ------ //
function correctionToDynamoDBDocClientObject(correction) {
    const items = {};
    const correctioneAny = correction;
    for (let key of Object.keys(correctioneAny)) {
        const dbKey = key.charAt(0).toUpperCase() + key.substring(1);
        const value = correctioneAny[key];
        if (typeof value === 'boolean') {
            items[dbKey] = String(correctioneAny[key]);
        }
        else if (typeof value === 'number') {
            items[dbKey] = correctioneAny[key];
        }
        else if (typeof value === 'string') {
            if (value.length > 0) {
                // Let's not fill up DynamoDB with empty strings...
                items[dbKey] = correctioneAny[key];
            }
        }
        else {
            console.log("Other type:" + key + " value:" + value);
        }
    }
    ;
    return items;
}
exports.correctionToDynamoDBDocClientObject = correctionToDynamoDBDocClientObject;
function fixCorrection(correction) {
    if (correction.currency) {
        correction.currency = correction.currency.toUpperCase();
    }
    if (correction.direction) {
        correction.direction = correction.direction.toUpperCase();
    }
    return correction;
}
exports.fixCorrection = fixCorrection;
function extractTransaction(correction) {
    const transaction = {};
    const correctionAny = correction;
    Object.keys(correctionAny)
        .filter((key) => {
        return key.startsWith('txn');
    })
        .forEach((key) => {
        let txnKey = key.substring(3);
        txnKey = txnKey.charAt(0).toLowerCase() + txnKey.substring(1);
        transaction[txnKey] = correctionAny[key];
    });
    return transaction;
}
exports.extractTransaction = extractTransaction;
function stampFromTransaction(correction, transaction) {
    const correctionAny = correction;
    const transactionAny = transaction;
    Object.keys(transactionAny)
        .forEach((key) => {
        const correctionAny = correction;
        const correctionKey = 'txn' + key.charAt(0).toUpperCase() + key.substring(1);
        correctionAny[correctionKey] = transactionAny[key];
    });
    return correctionAny;
}
exports.stampFromTransaction = stampFromTransaction;
function validateCorrection(correction) {
    const dateRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
    if (!correction.correctionKey) {
        return 'correctionKey is required';
    }
    if (!correction.eventDatetime) {
        return 'eventDatetime is required';
    }
    if (!correction.type) {
        return 'type is required';
    }
    if (!correction.settleDate) {
        return 'settleDate is required';
    }
    if (typeof correction.settleDate !== 'undefined' && !(dateRegex.test(correction.settleDate))) {
        return 'settleDate must be formatted YYYY-MM-DD';
    }
    if (!correction.direction) {
        return 'direction is required';
    }
    if (!correction.currency) {
        return 'currency is required';
    }
    if (!correction.amount) {
        return 'amount is required';
    }
    if (typeof correction.amount !== 'undefined' && typeof correction.amount !== 'number') {
        return 'amount must be a number';
    }
    if (!correction.desk) {
        return 'desk is required';
    }
    if (!correction.changeReason) {
        return 'changeReason is required';
    }
    if (!correction.username) {
        return 'username is required';
    }
    if (typeof correction.balanceCorrectionCalculatedAmount !== 'undefined' && typeof correction.balanceCorrectionCalculatedAmount !== 'number') {
        return 'balanceCorrectionCalculatedAmount must be a number';
    }
    if (typeof correction.balanceCorrectionOfficialAmount !== 'undefined' && typeof correction.balanceCorrectionOfficialAmount !== 'number') {
        return 'balanceCorrectionOfficialAmount must be a number';
    }
    if (typeof correction.projectionUpdateOriginalAmount !== 'undefined' && typeof correction.projectionUpdateOriginalAmount !== 'number') {
        return 'projectionUpdateOriginalAmount must be a number';
    }
    if (typeof correction.projectionUpdateNewAmount !== 'undefined' && typeof correction.projectionUpdateNewAmount !== 'number') {
        return 'projectionUpdateNewAmount must be a number';
    }
    if (typeof correction.txnSettleDate !== 'undefined' && !(dateRegex.test(correction.txnSettleDate))) {
        return 'txnSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnAmount !== 'undefined' && typeof correction.txnAmount !== 'number') {
        return 'txnAmount must be a number';
    }
    if (typeof correction.txnFxFxRate !== 'undefined' && typeof correction.txnFxFxRate !== 'number') {
        return 'txnFxFxRate must be a number';
    }
    if (typeof correction.txnMmRate !== 'undefined' && typeof correction.txnMmRate !== 'number') {
        return 'txnMmRate must be a number';
    }
    if (typeof correction.txnMmSpread !== 'undefined' && typeof correction.txnMmSpread !== 'number') {
        return 'txnMmSpread must be a number';
    }
    if (typeof correction.txnMmMaturityDate !== 'undefined' && !(dateRegex.test(correction.txnMmMaturityDate))) {
        return 'txnMmMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnMmSettleDate !== 'undefined' && !(dateRegex.test(correction.txnMmSettleDate))) {
        return 'txnMmSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnBondPrice !== 'undefined' && typeof correction.txnBondPrice !== 'number') {
        return 'txnBondPrice must be a number';
    }
    if (typeof correction.txnLoanOutstandingPrincipal !== 'undefined' && typeof correction.txnLoanOutstandingPrincipal !== 'number') {
        return 'txnLoanOutstandingPrincipal must be a number';
    }
    if (typeof correction.txnRepoRate !== 'undefined' && typeof correction.txnRepoRate !== 'number') {
        return 'txnRepoRate must be a number';
    }
    if (typeof correction.txnRepoMaturityDate !== 'undefined' && !(dateRegex.test(correction.txnRepoMaturityDate))) {
        return 'txnRepoMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnRepoSettleDate !== 'undefined' && !(dateRegex.test(correction.txnRepoSettleDate))) {
        return 'txnRepoSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnExportBillBillDate !== 'undefined' && !(dateRegex.test(correction.txnExportBillBillDate))) {
        return 'txnExportBillBillDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnExportBillSettleDate !== 'undefined' && !(dateRegex.test(correction.txnExportBillSettleDate))) {
        return 'txnExportBillSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnImportBillSettleDate !== 'undefined' && !(dateRegex.test(correction.txnImportBillSettleDate))) {
        return 'txnImportBillSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnLoanRate !== 'undefined' && typeof correction.txnLoanRate !== 'number') {
        return 'txnLoanRate must be a number';
    }
    if (typeof correction.txnLoanSpread !== 'undefined' && typeof correction.txnLoanSpread !== 'number') {
        return 'txnLoanSpread must be a number';
    }
    if (typeof correction.txnLoanMaturityDate !== 'undefined' && !(dateRegex.test(correction.txnLoanMaturityDate))) {
        return 'txnLoanMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnLoanSettleDate !== 'undefined' && !(dateRegex.test(correction.txnLoanSettleDate))) {
        return 'txnLoanSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnDepositRate !== 'undefined' && typeof correction.txnDepositRate !== 'number') {
        return 'txnDepositRate must be a number';
    }
    if (typeof correction.txnDepositMaturityDate !== 'undefined' && !(dateRegex.test(correction.txnDepositMaturityDate))) {
        return 'txnDepositMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof correction.txnDepositSettleDate !== 'undefined' && !(dateRegex.test(correction.txnDepositSettleDate))) {
        return 'txnDepositSettleDate must be formatted YYYY-MM-DD';
    }
    return true;
}
exports.validateCorrection = validateCorrection;
function parseCorrection(correction) {
    if (correction['amount']) {
        correction['amount'] = parseFloat(correction['amount']);
    }
    if (correction['balanceCorrectionCalculatedAmount']) {
        correction['balanceCorrectionCalculatedAmount'] = parseFloat(correction['balanceCorrectionCalculatedAmount']);
    }
    if (correction['balanceCorrectionOfficialAmount']) {
        correction['balanceCorrectionOfficialAmount'] = parseFloat(correction['balanceCorrectionOfficialAmount']);
    }
    if (correction['projectionUpdateOriginalAmount']) {
        correction['projectionUpdateOriginalAmount'] = parseFloat(correction['projectionUpdateOriginalAmount']);
    }
    if (correction['projectionUpdateNewAmount']) {
        correction['projectionUpdateNewAmount'] = parseFloat(correction['projectionUpdateNewAmount']);
    }
    if (correction['txnAmount']) {
        correction['txnAmount'] = parseFloat(correction['txnAmount']);
    }
    if (correction['txnPredictionEligible'] && typeof correction['txnPredictionEligible'] === 'string') {
        correction['txnPredictionEligible'] = string_utils_1.isTrueString(correction['txnPredictionEligible']) ? true : false;
    }
    if (correction['txnTimeSpecific'] && typeof correction['txnTimeSpecific'] === 'string') {
        correction['txnTimeSpecific'] = string_utils_1.isTrueString(correction['txnTimeSpecific']) ? true : false;
    }
    if (correction['txnClearing'] && typeof correction['txnClearing'] === 'string') {
        correction['txnClearing'] = string_utils_1.isTrueString(correction['txnClearing']) ? true : false;
    }
    if (correction['txnFlowScope']) {
        correction['txnFlowScope'] = parseFloat(correction['txnFlowScope']);
    }
    if (correction['txnFxFxRate']) {
        correction['txnFxFxRate'] = parseFloat(correction['txnFxFxRate']);
    }
    if (correction['txnMmRate']) {
        correction['txnMmRate'] = parseFloat(correction['txnMmRate']);
    }
    if (correction['txnMmSpread']) {
        correction['txnMmSpread'] = parseFloat(correction['txnMmSpread']);
    }
    if (correction['txnBondPrice']) {
        correction['txnBondPrice'] = parseFloat(correction['txnBondPrice']);
    }
    if (correction['txnBondOutstandingPrincipal']) {
        correction['txnBondOutstandingPrincipal'] = parseFloat(correction['txnBondOutstandingPrincipal']);
    }
    if (correction['txnRepoRate']) {
        correction['txnRepoRate'] = parseFloat(correction['txnRepoRate']);
    }
    if (correction['txnLoanRate']) {
        correction['txnLoanRate'] = parseFloat(correction['txnLoanRate']);
    }
    if (correction['txnLoanSpread']) {
        correction['txnLoanSpread'] = parseFloat(correction['txnLoanSpread']);
    }
    if (correction['txnLoanOutstandingPrincipal']) {
        correction['txnLoanOutstandingPrincipal'] = parseFloat(correction['txnLoanOutstandingPrincipal']);
    }
    if (correction['txnDepositRate']) {
        correction['txnDepositRate'] = parseFloat(correction['txnDepositRate']);
    }
    return correction;
}
exports.parseCorrection = parseCorrection;
//# sourceMappingURL=correction-converter.js.map